module.exports = __webpack_public_path__ + "static/media/how-to-use.afef380f.svg";